import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "yes",
  "use": "yes-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"yes\"><defs><style>#yes .cls-1{fill:none}</style></defs><title>资源 86</title><g id=\"yes_图层_2\" data-name=\"图层 2\"><g id=\"yes_图层_1-2\" data-name=\"图层 1\"><path id=\"yes_Rectangle_36_Copy_2\" data-name=\"Rectangle 36 Copy 2\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"yes_check\"><path id=\"yes_Shape\" d=\"M7.69 19.14h-.13a1 1 0 0 1-.69-.46l-3.73-6.54a.94.94 0 0 1 .33-1.29 1 1 0 0 1 1.29.33l3.12 5.46L19.4 5.13a.94.94 0 0 1 1.33 1.32L8.4 18.82l-.05.05a.94.94 0 0 1-.66.27z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/yes.svg
// module id = kWg0
// module chunks = 6